import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import ErrorBoundary from "@/components/ErrorBoundary";

// Public pages
import HomePage from "@/pages/HomePage";
import CataloguePage from "@/pages/CataloguePage";
import ProductPage from "@/pages/ProductPage";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import CheckoutSuccessPage from "@/pages/CheckoutSuccessPage";
import CheckoutCancelPage from "@/pages/CheckoutCancelPage";
import SuiviCommandePage from "@/pages/SuiviCommandePage";
import BlogPage from "@/pages/BlogPage";
import NotreHistoirePage from "@/pages/NotreHistoirePage";
import OuNousTrouverPage from "@/pages/OuNousTrouverPage";

import NotFoundPage from "@/pages/NotFoundPage";

import AdminCMS from "@/pages/admin/AdminCMS";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminShipping from "@/pages/admin/AdminShipping";
import AdminGiftCards from "@/pages/admin/AdminGiftCards";
import AdminMedia from "@/pages/admin/AdminMedia";
import BonCadeauPage from "@/pages/BonCadeauPage";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

// Wrapper interne — on veut le pathname pour reset auto de l'ErrorBoundary
// à chaque navigation. Sans ça, une page cassée piégerait l'utilisateur
// même après un clic sur le logo.
function AppRoutes() {
  const { pathname } = useLocation();
  return (
    <ErrorBoundary resetKey={pathname}>
      <Routes>
            {/* Public routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/commander-en-ligne" element={<CataloguePage />} />
            <Route path="/commander-en-ligne/:categorySlug" element={<CataloguePage />} />
            {/* Redirect old /catalogue URLs */}
            <Route path="/catalogue" element={<CataloguePage />} />
            <Route path="/catalogue/:categorySlug" element={<CataloguePage />} />
            <Route path="/produit/:slug" element={<ProductPage />} />
            <Route path="/panier" element={<CartPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
            <Route path="/checkout/cancel" element={<CheckoutCancelPage />} />
            <Route path="/bon-cadeau" element={<BonCadeauPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/notre-histoire" element={<NotreHistoirePage />} />
            <Route path="/ou-nous-trouver" element={<OuNousTrouverPage />} />
            <Route path="/suivi-commande" element={<SuiviCommandePage />} />
            
            {/* Admin routes */}
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/products" element={<AdminProducts />} />
            <Route path="/admin/categories" element={<AdminCategories />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
            <Route path="/admin/cms" element={<AdminCMS />} />
            <Route path="/admin/shipping" element={<AdminShipping />} />
            <Route path="/admin/gift-cards" element={<AdminGiftCards />} />
            <Route path="/admin/media" element={<AdminMedia />} />
            
            {/* 404 catch-all */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
    </ErrorBoundary>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <AppRoutes />
          <Toaster position="top-right" richColors />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
